module.exports = __webpack_public_path__ + "img/avatar-4.7a89b105.png";